import { flow } from 'es-toolkit';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { player } from 'src/client/player';
import { playerStatuses } from 'src/common/constants/playerStatuses';
import { useStores } from '../providers';
import { selectIsMobile } from '../selectors/app';
import { withReactHooks } from './withReactHooks';

const playerManagerPlayerAction = (_, __, guideItem, skipPreroll) =>
  player.onClick(guideItem, { skipPreroll });

export function mapStateToProps(state) {
  return {
    isMobile: selectIsMobile(state),
  };
}

export default function connectWithPlayer(MyComponent) {
  /* eslint-disable react/prefer-stateless-function */
  class ConnectWithPlayer extends Component {
    static propTypes = {
      guideItem: PropTypes.object,
      playerStatus: PropTypes.string.isRequired,
      actions: PropTypes.object,
      isMobile: PropTypes.bool.isRequired,
      legacyAutoPlayGuideItem: PropTypes.object,
      canScrub: PropTypes.bool,
      tunedGuideId: PropTypes.string,
    };

    state = {
      autoplayGuideItem: null,
    };

    render() {
      const { playerStatus, guideItem, tunedGuideId } = this.props;
      const { autoplayGuideItem } = this.state;
      const playGuideId = guideItem?.actions?.play?.guideId;
      const isPrimedForAutoPlay =
        playerStatus === playerStatuses.idle && playGuideId === autoplayGuideItem?.playableGuideId;
      const isSyncedWithPlayer = !!(
        playGuideId &&
        playGuideId === tunedGuideId &&
        // we still need to tune in the case when !isPrimedForAutoPlay which is why
        // it's not considered to be in sync with player
        !isPrimedForAutoPlay
      );
      const syncedPlayerStatus = isSyncedWithPlayer ? playerStatus : playerStatuses.idle;

      return (
        <MyComponent
          {...this.props}
          isSyncedWithPlayer={isSyncedWithPlayer}
          syncedPlayerStatus={syncedPlayerStatus}
          syncedPlayerAction={playerManagerPlayerAction}
        />
      );
    }
  }

  return flow(
    connect(mapStateToProps),
    withReactHooks(() => {
      const { playerStore } = useStores();
      const metadata = playerStore.metadata();

      return {
        playerStatus: playerStore.playerStatus(),
        tunedGuideId: playerStore.currentGuideItem()?.playableGuideId,
        canScrub: !metadata?.isUnboundedStream,
        autoplayGuideItem: metadata?.autoplayGuideItem,
      };
    }),
  )(ConnectWithPlayer);
}
